<template>
  <div :class="b()">
    <c-product-image
      :class="b('image')"
      :images="asset?.image ? [asset.image] : []"
      :picture-sizes="pictureSizes"
    />
    <div :class="b('content-wrapper')">
      <div :class="b('heading-description-wrapper')">
        <h3
          v-if="heading"
          :class="b('heading')"
        >
          {{ heading }}
        </h3>
        <div
          v-if="asset?.description"
          :class="b('description')"
        >
          {{ asset.description }}
        </div>
      </div>
      <div
        v-if="asset?.bookLink || asset?.orderLink || asset?.downloadLink"
        :class="b('cta-btns-wrapper')"
      >
        <e-button
          v-if="asset?.bookLink"
          :class="b('cta-btn')"
          :href="asset.bookLink"
          target="_blank"
          rel="noopener noreferrer"
          :title="$t('c-teaser-tile-asset.bookLinkLabel')"
          :aria-label="$t('c-teaser-tile-asset.bookLinkLabel')"
        >
          <span :class="b('cta-btn-icon-label-wrapper')">
            <e-icon
              :class="b('cta-btn-icon')"
              icon="i-book"
              size="16"
            />
          </span>
        </e-button>
        <e-button
          v-if="asset?.downloadLink"
          :class="b('cta-btn')"
          :href="asset.downloadLink"
          target="_blank"
          rel="noopener noreferrer"
          :title="$t('c-teaser-tile-asset.downloadLinkLabel')"
          :aria-label="$t('c-teaser-tile-asset.downloadLinkLabel')"
        >
          <span :class="b('cta-btn-icon-label-wrapper')">
            <e-icon
              :class="b('cta-btn-icon')"
              icon="i-download"
              size="16"
            />
          </span>
        </e-button>
        <e-button
          v-if="asset?.orderLink"
          :class="b('cta-btn')"
          :href="asset.orderLink"
          target="_blank"
          rel="noopener noreferrer"
          :title="$t('c-teaser-tile-asset.orderLinkLabel')"
          :aria-label="$t('c-teaser-tile-asset.orderLinkLabel')"
        >
          <span :class="b('cta-btn-icon-label-wrapper')">
            <e-icon
              :class="b('cta-btn-icon')"
              icon="i-worker"
              size="16"
            />
          </span>
        </e-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import { PRODUCT_DISPLAY_PICTURE_SIZES } from '@/setup/globals';
  import cProductImage from '@/components/c-product-image.vue';
  import eButton from '@/elements/e-button.vue';
  import eIcon from '@/elements/e-icon.vue';
  import { DownloadCenterAsset } from '@/types/download-center-asset';
  import { ImageSizes } from '@/types/sizes';

  // type Setup = {};

  type Data = {
    pictureSizes: ImageSizes;
  };

  /**
   * Shows a teaser tile link
   */
  export default defineComponent({
    name: 'c-teaser-tile-download-center',

    components: {
      cProductImage,
      eButton,
      eIcon,
    },

    props: {
      /**
       * The Download Center Asset to display
       */
      asset: {
        type: Object as PropType<DownloadCenterAsset | null>,
        default: null,
      },
    },
    // emits: {},

    // setup(): Setup {
    //   return {}
    // },

    data(): Data {
      return {
        pictureSizes: PRODUCT_DISPLAY_PICTURE_SIZES,
      };
    },

    computed: {
      heading(): string | number {
        if (!this.asset) {
          return '';
        }

        return !this.asset.heading || this.asset.heading === 'null' ? this.asset.id : this.asset.heading;
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  @use 'sass:map';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/variables';

  .c-teaser-tile-download-center {
    $this: &;

    display: flex;
    align-items: center;
    flex-direction: column;
    border: 1px solid var(--theme-color-grayscale--900);
    height: 100%;

    &__cta-btn-wrapper {
      height: 3rem;
    }

    &__cta-btn {
      border-radius: 100px;
      background-color: var(--theme-color-grayscale--950);
    }

    .e-button:hover:not(.e-button--touch) {
      text-decoration: none;
    }

    &__cta-btn-icon {
      color: var(--theme-color-primary--1);
      flex-shrink: 0;
    }

    &__cta-btn-icon-label-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      padding: 0.75rem;
      color: rgba(var(--theme-color-grayscale--0-rgb), 0.5);
    }

    &__image {
      width: 100%;
      min-height: 16rem;
      aspect-ratio: 1; // Square by default.
    }

    &__content-wrapper {
      @include mixins.hyphens();

      width: 100%;
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      gap: 1rem;
      color: var(--theme-color-grayscale--950);
      background-color: var(--theme-color-primary--1);
      padding: 1.5rem;
    }

    &__cta-btns-wrapper {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      margin-top: auto;
    }

    &__heading-description-wrapper {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    &__heading {
      @include mixins.heading-h4;
    }

    &__description {
      @include mixins.line-clamp(2, 1.5);

      font-size: variables.$font-size--small;
    }
  }
</style>
